import React, { useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import {  Grid  } from "semantic-ui-react";
import InputField from "../../../../commonComponents/formComponents/inputField";
import DropDown from "../../../../commonComponents/formComponents/dropDown";
import { useUpdateEffect } from "../../../../hooks";
import PopUpIcon from "../../../../commonComponents/formComponents/PopUpIcon";
import { ActorContext } from "../../partiesTab/Actors/actorProvider";
import { convertDateToUTC,convertDateToUTCEpoch } from "../../../../Helper/date";

const SecurityInfo=({saveData,onUpdate,renderItinerary,translate})=>{

  const specialCircumstancesList = useSelector((state) => state.DropDownValues.specialCircumstances);
  const securityList = useSelector((state) => state.DropDownValues.securities);
  const {specialCircumstances,security,itinerary,presentation} = useSelector((state) => state.Shipment.transportation);
  const carrierId=useSelector((state) => state.Actor.carrier.id)
  const { updateActorFieldValue,saveActorDetails }=useContext(ActorContext)
  
  
  const disableForm=useMemo(()=> (security=="0"),[security])



  useUpdateEffect(()=>{
    if(disableForm){
      if(carrierId){ // if data is available
        saveActorDetails({actorType:"carrier",name:" ",eoriNo:" ",addressLine1:" ",addressLine2:" ",city:" ",state:" ",postalCode:" ",country:" "})
        updateActorFieldValue("carrier",{id:"",name:"",eoriNo:"",addressLine1:"",addressLine2:"",city:"",state:"",postalCode:"",country:""})
      }
      saveData({specialCircumstances:" ",presentation:" ",itinerary:" "})
      onUpdate({"specialCircumstances":"","presentation":"",itinerary:""})
    }
    if(security==2){
      saveData({specialCircumstances:specialCircumstancesList[0]?.value})
      onUpdate({"specialCircumstances":specialCircumstancesList[0]?.value})
    }
 },[disableForm,security])
 
 return (

            
            <Grid.Row>
          <Grid.Column width="4" className="divFormFeild">
          <DropDown
                id="security"
                label={
                  <React.Fragment>
                  <PopUpIcon  icon="info circle"
                  popupText={<ul><li>{translate("IF_SECURITY_IS_0_THEN_SPECIAL,PRESENTATION,ITENERY_ARE_NOT_REQUIRED_AND_WILL_BE_DISABLED", {ns:["default", "header"]})}</li></ul>}></PopUpIcon>
                  {translate("SECURITY", {ns:["default", "header"]})}
                  </React.Fragment>
                }
                data={securityList}
                className="field-bg dropdown100"
                boxNumber="15"
                value={security}
               onChange={(value) =>{
                saveData({"security":value})
                onUpdate({"security":value})}    
               }
              
            />
          
          </Grid.Column>
          <Grid.Column width="4" className="divFormFeild">
          <DropDown
                id="specialCicumstances"
                label={translate("SPECIAL_CIRCUMSTANCES", {ns:["default", "header"]})}
                data={specialCircumstancesList}
                disabled={disableForm}
                className="field-bg dropdown100"
                boxNumber="15"
                value={specialCircumstances}
               onChange={(value) =>{
                 saveData({specialCircumstances:value})
                 onUpdate({"specialCircumstances":value})
                }}  
             
            />
         
     
         
          </Grid.Column>
          <Grid.Column width="4" className="divFormFeild datepicker1 b-bw-1">
          
            <InputField
              isLabel={false}
              id="presentation"
              type="date"
              mandatory={false}
              boxNumber="21"
              label={translate("PRESENTATION", {ns:["default", "header"]})}
              value={convertDateToUTC(presentation)}
              className="field-bg"
              clearInput={false}
              disabled={disableForm}    
              onChange={(value) => {
                value=convertDateToUTCEpoch(value)
                saveData({"presentation":value || " "})
                onUpdate({"presentation":value})}
              }
              
            />
          </Grid.Column>
          <Grid.Column width="4" className="divFormFeild">

            {renderItinerary && renderItinerary({disabled:disableForm,errors:!disableForm && !itinerary && ["Itinerary is mandatory if selected value of security is 2"]})}
          
              </Grid.Column>
        </Grid.Row>
        
      
    
  );
}

export default React.memo(SecurityInfo)
